// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2ZdQn","list":"styles_list__2dOEH"};